import { useTranslation } from 'react-i18next'

import { useInitData } from '../../../../hooks'
import { parseServerValidation } from '../../../../utils/validation'
import { FormikForm } from '../../../Formik'
import { login } from '../Login.api'
import { LoginFormBody } from '../LoginFormBody'

import { LoginAsEmployeeButton } from './LoginAsEmployeeButton'
import { LOGIN_FORM_EMAIL_INITIAL_VALUES } from './LoginFormEmail.constants'
import {
  getLoginFormValidationSchema,
  parseLoginFormEmailServerError,
} from './LoginFormEmail.utils'
import { LoginFormEmailFields } from './LoginFormEmailFields'

function LoginFormEmail({
  getValidationSchema = getLoginFormValidationSchema,
  initialValues = LOGIN_FORM_EMAIL_INITIAL_VALUES,
  onRemoveNotification,
  onSetNotification,
  onSuccess,
}) {
  const { t } = useTranslation()

  const initData = useInitData()

  const validationSchema = getValidationSchema()

  function handleSubmit(data, { setErrors, setSubmitting }) {
    login(data)
      .then(onSuccess)
      .catch(error => {
        setErrors(parseServerValidation(parseLoginFormEmailServerError(error)))
      })
      .finally(() => {
        setSubmitting(false)
      })
  }

  return (
    <FormikForm
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      <LoginFormBody
        actionsProps={{
          LoginAsEmployeeButton: initData.sso?.enabled
            ? LoginAsEmployeeButton
            : null,
          submitText: t('Auth.SignInByEmailSubmitBtnKey'),
        }}
        helpText={t('Auth.SignInByEmailTextKey')}
        onRemoveNotification={onRemoveNotification}
        onSetNotification={onSetNotification}
      >
        <LoginFormEmailFields
          onRemoveNotification={onRemoveNotification}
          onSetNotification={onSetNotification}
        />
      </LoginFormBody>
    </FormikForm>
  )
}

export default LoginFormEmail
